import React from 'react';
import { Route, Switch, Redirect, useRouteMatch } from 'react-router-dom';

import { useWorkspace } from '@mssgme/hooks';
import { Feature } from '@mssgme/ui';

import OnboardPage from './OnboardPage';
import ChatPage from './ChatPage';
import usePushMessaging from './usePushMessaging';

export default function InboxPage() {
    const workspace = useWorkspace();
    const match = useRouteMatch();

    const hasIntegrations = workspace.integrations.length > 0;
    const reason = { code: 'inbox', plan: 'pro' };

    usePushMessaging(hasIntegrations);

    return (
        <Feature rule="inbox" reason={reason} center>
            <Switch>
                <Route path={`${match.path}/onboard`} component={OnboardPage} />
                {hasIntegrations ? (
                    <Route path={`${match.path}`} component={ChatPage} />
                ) : (
                    <Redirect to={`${match.path}/onboard`} />
                )}
            </Switch>
        </Feature>
    );
}
